import { Helmet } from 'react-helmet-async';
import { useOrganizationSEO } from '@/hooks/useOrganizationSEO';

export const DynamicOrganizationStructuredData = () => {
  const { settings, getSocialLinks } = useOrganizationSEO();

  if (!settings) return null;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: settings.orgName,
    description: settings.orgDescription,
    url: settings.orgUrl,
    logo: settings.orgLogo || undefined,
    sameAs: getSocialLinks().length > 0 ? getSocialLinks() : undefined,
    contactPoint: settings.orgEmail
      ? {
          '@type': 'ContactPoint',
          email: settings.orgEmail,
          contactType: 'customer service',
        }
      : undefined,
    foundingDate: settings.orgFoundingDate || undefined,
  };

  // Remove undefined values
  const cleanData = JSON.parse(JSON.stringify(structuredData));

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(cleanData)}</script>
    </Helmet>
  );
};

export const DynamicWebSiteStructuredData = () => {
  const { settings } = useOrganizationSEO();

  if (!settings) return null;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: settings.orgName,
    url: settings.orgUrl,
    potentialAction: settings.searchUrlTemplate
      ? {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: settings.searchUrlTemplate,
          },
          'query-input': 'required name=search_term_string',
        }
      : undefined,
  };

  const cleanData = JSON.parse(JSON.stringify(structuredData));

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(cleanData)}</script>
    </Helmet>
  );
};
